import { render, staticRenderFns } from "./winUrlLink.vue?vue&type=template&id=2f788858"
import script from "./winUrlLink.vue?vue&type=script&lang=js"
export * from "./winUrlLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports